export const GALLERY_BLOT_CONSTS = {
  galleryEditing: 'Редактирование галереи',
  galleryDeleting: 'Удаление галереи',
  nextTitle: 'Следующее фото',
  prevTitle: 'Предыдущее фото'
}
